<style lang="less" scoped>
.ivu-tabs-tabpane {
  .ivu-row {
    margin: 0 !important;
  }
}

.footer {
  margin-top: 30px;
  text-align: right;

  .cancel {
    margin-left: 10px;
  }
}
</style>
<template>
  <div>
    <Modal title="学员基本信息" v-model="visible" width="1000px">
      <Tabs type="card" @on-click="onTabClick" v-model="tabName">
        <Tab-pane label="基本信息">
          <Form ref="userInfoForm" class="form"
                :model="formData" :rules="userRule">
            <Row :gutter="24">
              <i-col span="14" style="border-right: 1px dotted #ddd;">
                <Row :gutter="24">
                  <i-col :xs="14" :sm="8" :md="14">
                    <Row :gutter="12">
                      <i-col :xs="12" :sm="8" :md="20">
                        <Form-item :label-width="120" label="英文名字：">
                          <Input name="enName" v-model="formData.enName"></Input>
                        </Form-item>
                      </i-col>
                    </Row>
                    <Row :gutter="12">
                      <i-col :xs="12" :sm="8" :md="20">
                        <Form-item :label-width="120" label="密码：">
                          <Input type="password" name="enName" v-model="formData.password"></Input>
                        </Form-item>
                      </i-col>
                    </Row>
                    <Row :gutter="15">
                      <i-col :xs="12" :sm="8" :md="20">
                        <Form-item :label-width="120" label="中文名字：">
                          <Input name="enName" v-model="formData.cnName"></Input>
                        </Form-item>
                      </i-col>
                    </Row>
                    <Row :gutter="15">
                      <i-col :xs="12" :sm="8" :md="20">
                        <Form-item :label-width="120" label="年龄：" prop="age">
                          <Input name="enName" v-model="formData.age"></Input>
                        </Form-item>
                      </i-col>
                    </Row>
                    <Row :gutter="22">
                      <i-col :xs="12" :sm="8" :md="20">
                        <Form-item :label-width="120" label="性别：">
                          <Select v-model="formData.sex" transfer>
                            <Option v-for="item in $constant.sex"
                                    :value="item.code" :key="item.code">{{ item.text }}
                            </Option>
                          </Select>
                        </Form-item>
                      </i-col>
                    </Row>
                    <Row :gutter="22">
                      <i-col :xs="12" :sm="8" :md="20">
                        <Form-item :label-width="120" label="年级：">
                          <Select v-model="formData.grade" transfer>
                            <Option v-for="item in $constant.grade"
                                    :value="item.code" :key="item.code">{{ item.text }}
                            </Option>
                          </Select>
                        </Form-item>
                      </i-col>
                    </Row>
                    <Row :gutter="22">
                      <i-col :xs="12" :sm="8" :md="20">
                        <Form-item :label-width="120" label="生日：">
                          <el-date-picker
                            v-model.number="formData.birthday"
                            type="date"
                            placeholder="选择日期"
                            format="yyyy-MM-dd"
                            value-format="timestamp"
                          >
                          </el-date-picker>
                        </Form-item>
                      </i-col>
                    </Row>
                  </i-col>
                  <i-col :xs="10" :sm="8" :md="7">
                    <a @click="openStudentPage"><img :src="totalImageUrl" style="width: 120px;height: 120px"></a>
                    <single-one-pic-upload @on-file-change="handleResult" :text="text"/>
                  </i-col>
                </Row>
                <Row :gutter="15">
                  <i-col>
                    <Form-item :label-width="80" label="生源地：">
                      <v-distpicker :province="formData.province" :city="formData.city" :area="formData.block"
                                    @province="onSelectedProvince" @city="onSelectedCity" @area="onSelectedArea"
                                    :placeholders="placeholders"></v-distpicker>
                    </Form-item>
                  </i-col>
                </Row>
                <Row :gutter="15">
                  <i-col :xs="12" :sm="8" :md="22">
                    <Form-item :label-width="120" label="英语学习经历：">
                      <Select v-model="formData.learnEnglishTime" transfer>
                        <Option value="1">不足三个月</Option>
                        <Option value="2">一年左右</Option>
                        <Option value="3">一年以上</Option>
                        <Option value="4">没有学习过英语</Option>
                      </Select>
                    </Form-item>
                  </i-col>
                </Row>
                <Row :gutter="20">
                  <i-col :xs="12" :sm="8" :md="24">
                    <Form-item :label-width="120" label="是否接触过外教：">
                      <RadioGroup v-model="formData.haveContactForeignTeacher">
                        <Radio label="-1">
                          <span>否</span>
                        </Radio>
                        <Radio label="1">
                          <span>是</span>
                        </Radio>
                        <Radio label="0">
                          <span>不确定</span>
                        </Radio>
                      </RadioGroup>
                    </Form-item>
                  </i-col>
                </Row>
                <Row :gutter="24">
                  <i-col :xs="12" :sm="8" :md="22">
                    <Form-item :label-width="120" label="家庭经济情况：">
                      <RadioGroup v-model="formData.familyEconomicSituation">
                        <Radio label="1">
                          <span>非常好</span>
                        </Radio>
                        <Radio label="2">
                          <span>一般</span>
                        </Radio>
                        <Radio label="3">
                          <span>不是很好</span>
                        </Radio>
                        <Radio label="0">
                          <span>不确定</span>
                        </Radio>
                      </RadioGroup>
                    </Form-item>
                  </i-col>
                </Row>
                <Row :gutter="20">
                  <i-col :xs="12" :sm="8" :md="24">
                    <Form-item :label-width="120" label="是否重视英语学习：">
                      <RadioGroup v-model="formData.attentionEnglish">
                        <Radio label="1">
                          <span>是</span>
                        </Radio>
                        <Radio label="2">
                          <span>否</span>
                        </Radio>
                        <Radio label="0">
                          <span>不确定</span>
                        </Radio>
                      </RadioGroup>
                    </Form-item>
                  </i-col>
                </Row>
                <Row :gutter="20">
                  <i-col :xs="12" :sm="8" :md="24">
                    <Form-item :label-width="120" label="接通状态：">
                      <RadioGroup v-model="formData.connectionStatus">
                        <Radio label="1">
                          <span>未拨打</span>
                        </Radio>
                        <Radio label="2">
                          <span>拨打未接</span>
                        </Radio>
                        <Radio label="3">
                          <span>拨打接通</span>
                        </Radio>
                        <Radio label="4">
                          <span>无效资源</span>
                        </Radio>
                      </RadioGroup>
                    </Form-item>
                  </i-col>
                </Row>
              </i-col>
              <i-col span="10">
                <Row :gutter="12">
                  <Tag style="margin:0 0 20px 20px" color="yellow">联系方式</Tag>
                </Row>
                <Row :gutter="12">
                  <Form-item :label-width="100" label="学生ID：">
                    <label>{{ formData.uid }}</label>
                  </Form-item>
                </Row>
                <Row :gutter="12">
                  <Form-item :label-width="100" label="手机号码：" prop="mobile">
                    <Input v-model="formData.mobile" style="width: 120px" disabled></Input>
                  </Form-item>
                </Row>
                <Row :gutter="12">
                  <Form-item :label-width="100" label="号码对应人：">
                    <RadioGroup v-model="formData.phoneRole">
                      <Radio label="1">
                        <span>父亲</span>
                      </Radio>
                      <Radio label="2">
                        <span>母亲</span>
                      </Radio>
                      <Radio label="3">
                        <span>其他</span>
                      </Radio>
                    </RadioGroup>
                  </Form-item>
                </Row>
                <Button type="primary" @click="addContact">添加联系人</Button>
                <Form-item prop="userContacts">
                  <div v-for="(item, index) in formData.userContacts">
                    <Row :gutter="22">
                      <Form-item style="margin-top: 10px">
                        <i-col span="10">
                          <Input placeholder="姓名" v-model="formData.userContacts[index].name"></Input>
                        </i-col>
                        <i-col span="10">
                          <Input placeholder="手机号码" v-model="formData.userContacts[index].mobile"
                                 :number="true"></Input>
                        </i-col>
                        <Button @click="deleteContact(index)">删除</Button>
                      </Form-item>
                    </Row>
                  </div>
                </Form-item>
                <Row :gutter="12">
                  <Form-item :label-width="100" label="微信账号：" prop="weChat">
                    <Input v-model="formData.weChat" style="width: 120px"></Input>
                  </Form-item>
                </Row>
                <Row :gutter="12">
                  <Form-item :label-width="100" label="地址：">
                    <Input v-model="formData.address" type="textarea" :autosize="true"></Input>
                  </Form-item>
                </Row>
                <Row :gutter="12">
                  <Form-item :label-width="100" label="个人信息备注：">
                    <Input v-model="formData.infoRemark" type="textarea" :autosize="true"></Input>
                  </Form-item>
                </Row>
              </i-col>
            </Row>
            <hr style="border: 1px dotted #ddd">
            <div style="margin-top: 10px">
              <Row :gutter="24">
                <Row :gutter="20">
                  <i-col span="14" style="border-right: 1px dotted #ddd;">
                    <Row :gutter="12">
                      <Tag style="margin-left: 10px" color="yellow">学生来源标签</Tag>
                    </Row>
                    <Form-item :label-width="80" label="注册渠道：" style="margin-top: 10px">
                      <Input name="regType" v-model="formData.regType" disabled/>
                      <!-- <Select v-model.number="formData.regType" transfer>
                          <Option v-for="item in  $constant.studentCanal"
                                  :value="item.code" :key="item.code">{{ item.text }}</Option>
                      </Select> -->
                    </Form-item>
                    <Row :gutter="10">
                      <i-col span="20">
                        <Form-item :label-width="77" label="付费渠道：">
                          <RadioGroup v-model="formData.payCanal" v-for="item in $constant.studentTags">
                            <Radio :label="item.code">
                              <span>{{ item.text }}</span>
                            </Radio>
                          </RadioGroup>
                        </Form-item>
                      </i-col>
                    </Row>
                    <hr style="border: 1px dotted #ddd">
                    <div style="margin-top: 20px"/>
                    <Row :gutter="22">
                      <Tag style="margin-left: 30px" color="yellow">课顾电话跟进</Tag>
                    </Row>
                    <div style="margin:20px">
                      <Row :gutter="22">
                        <i-col span="20">
                          <span style="font-size: 15px">意向等级：</span>
                          <RadioGroup v-model="formData.intentLevel">
                            <Radio label="">
                              <span>不论</span>
                            </Radio>
                            <Radio label="1">
                              <span>高意向</span>
                            </Radio>
                            <Radio label="2">
                              <span>意向一般</span>
                            </Radio>
                            <Radio label="3">
                              <span>待跟进</span>
                            </Radio>
                            <Radio label="4">
                              <span>无效资源</span>
                            </Radio>
                          </RadioGroup>
                        </i-col>
                      </Row>
                    </div>
                  </i-col>
                  <i-col span="9" style="height: 326px;border-bottom: 1px dotted #ddd;">
                    <Row :gutter="12">
                      <Tag style="margin-left: 30px;margin-bottom: 10px;" color="yellow">学生属性标签</Tag>
                    </Row>
                    <Row :gutter="12">
                    <span style="display:inline-block;margin:0 0 10px 40px;" v-for="(val, key) in userModal"
                          v-if="key=='学习经历'">学习经历:
                      <Tag style="margin-left: 10px" color="#80848f" v-for="item in val">{{ item }}</Tag>
                    </span>
                    </Row>
                    <Row :gutter="12">
                   <span style="display:inline-block;margin:0 0 10px 40px;" v-for="(val, key) in userModal"
                         v-if="key=='英语水平'">英语水平:
                    <Tag style="margin-left: 10px" color="#80848f" v-for="item in val">{{ item }}</Tag>
                    </span>
                    </Row>
                    <Row :gutter="12">
                    <span style="display:inline-block;margin:0 0 10px 40px;" v-for="(val, key) in userModal"
                          v-if="key=='孩子性格'">孩子性格:
                      <Tag style="margin-left: 10px" color="#80848f" v-for="item in val">{{ item }}</Tag>
                    </span>
                    </Row>
                    <Row :gutter="12">
                   <span style="display:inline-block;margin:0 0 10px 40px;" v-for="(val, key) in userModal"
                         v-if="key=='兴趣爱好'">兴趣爱好:
                    <Tag style="margin-left: 10px" color="#80848f" v-for="item in val">{{ item }}</Tag>
                    </span>
                    </Row>
                    <Row :gutter="12">
                   <span style="margin-left: 40px;font-size: 15px" v-for="(val, key) in userModal"
                         v-if="key=='老师要求'">老师要求:
                     <span v-if="val!=null">
                      <Tag style="margin-left: 10px" color="#80848f" v-for="item in val">{{ item }}</Tag>
                     </span>
                     <span>
                       无
                     </span>
                    </span>
                    </Row>
                  </i-col>
                </Row>
              </Row>
            </div>
          </Form>
          <div class="telephone">
            <Button shape="circle" @click="dialTel"></Button>
          </div>
          <Table border :i-columns="title" :data="telDetails"></Table>

          <div class="footer">
            <Button type="primary" size="large" :loading="insertLoading" @click="addStudent">保存</Button>
            <Button type="primary" size="large" class="cancel" @click="visible=false">取消</Button>
          </div>
        </Tab-pane>
        <!--follow up-->
        <Tab-pane label="follow up">
          <Form ref="followForm" class="form" :model="followFormData" :rules="followRule">
            <Row :gutter="24">
              <Tag color="yellow">follow up</Tag>
            </Row>
            <Row :gutter="24">
              <i-col span="6" style="padding-left: 0;">
                <Form-item label="学生：" :label-width="80">
                  <label>{{ followFormData.id }} -- {{ followFormData.nickname }}</label>
                </Form-item>
              </i-col>
              <i-col span="6">
                <Form-item label="课程顾问：" :label-width="80">
                  <label>{{ followFormData.adviserName }}</label>
                </Form-item>
              </i-col>
              <i-col span="6">
                <Form-item label="学导：" :label-width="80">
                  <label>{{ followFormData.studyAdviserName }}</label>
                </Form-item>
              </i-col>
              <i-col span="6">
                <Form-item label="绑定老师：" :label-width="80">
                  <label v-for="tchName in followFormData.tchNames">{{ tchName }}<br/></label>
                </Form-item>
              </i-col>
            </Row>
            <Row :gutter="20">
              <Form-item label="内容：" prop="content" :label-width="80">
                <Input v-model="followFormData.content" type="textarea" :rows="4" placeholder="请输入..."></Input>
              </Form-item>
            </Row>
            <Row>
              <i-col span="10">
                <Form-item label="状态：" prop="traceStatus" :label-width="80">
                  <Select v-model="followFormData.traceStatus" @on-change="changeFollow" transfer>
                    <Option value="1">高跟进</Option>
                    <Option value="2">跟进中</Option>
                    <Option value="3">跟进低</Option>
                    <Option value="4">无意向</Option>
                    <Option value="5">多次联系不到</Option>
                    <Option value="100">注册备注</Option>
                  </Select>
                </Form-item>
              </i-col>
              <i-col span="10">
                <Form-item :label-width="50" prop="traceItem">
                  <Select v-model="followFormData.traceItem" transfer>
                    <Option v-for="item in followList"
                            :value="item.id" :key="item.id">{{ item.text }}
                    </Option>
                  </Select>
                </Form-item>
              </i-col>
            </Row>
            <Row :gutter="20" v-if="followFormData.traceStatus == 100 || followFormData.traceStatus == '100'">
              <Form-item label="上传截图" :label-width="80">
                <multiple-image-upload :num="100" v-model="followFormData.files"/>
              </Form-item>
            </Row>
            <Row :gutter="20">
              <Form-item label="下次联系时间：" prop="nextDate" :label-width="80">
                <DatePicker v-model="nextDate" type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                            @on-change="changeDate"></DatePicker>
              </Form-item>
            </Row>
            <Row :gutter="20">
              <Form-item label="对老师要求：" :label-width="80">
                <ElSwitch v-model="askForTch"></ElSwitch>
              </Form-item>
              <template v-if="askForTch">
                <Form-item label="对学生描述：" :label-width="80">
                  <el-checkbox-group v-model="followFormData.stuDescCheckGroup" size="mini" :max="3">
                    <el-checkbox v-for="item in $constant.stuDesc" :label="item.code" :key="item.code" border>
                      {{ item.text }}
                    </el-checkbox>
                  </el-checkbox-group>
                </Form-item>
                <Form-item label="对老师要求：" :label-width="80">
                  <el-checkbox-group v-model="followFormData.askForTchCheckGroup" size="mini" :max="5">
                    <el-checkbox v-for="item in $constant.askForTch" :label="item.code" :key="item.code" border>
                      {{ item.text }}
                    </el-checkbox>
                  </el-checkbox-group>
                </Form-item>
              </template>
            </Row>
            <div style="margin: 0 0 40px 35px;">
              <Button type="primary" style="margin-right: 20px;" @click="addFollow">保存</Button>
              <Button type="primary" @click="visible=false">取消</Button>
            </div>
          </Form>
          <Row :gutter="24">
            <Tag color="yellow" style="margin-bottom: 15px">follow up记录</Tag>
          </Row>
          <Table border :columns="followtitle" :data="followData" :reload="reload"></Table>
        </Tab-pane>
        <!--推荐老师-->
        <Tab-pane label="推荐老师">
          <Button type="primary" @click="openRecommendEdit">添加老师</Button>
          <RecommendList style="margin-top: 10px" :uid="formData.uid" listUrl="/tchRecommend/list"
                         :tableColumns="recommendTitle" :reset="reset" :data="recommendData"></RecommendList>
        </Tab-pane>
        <Tab-pane label="阶段报告">
          <!-- <Button type="primary"  @click="insertReport">添加阶段报告</Button>-->
          <Table border :columns="stageReportTitle" :data="stageReportData" :reload="reload"
                 style="margin-top: 10px"></Table>
        </Tab-pane>
        <Tab-pane label="学生跟踪记录">
          <Form ref="form" :model="formValidate" :rules="ruleValidate" :label-width="90" class="form">
            <Row>
              <Col :sm="11" :md="5">
                <Form-item label="学生ID">
                  <Input readonly v-model.number="formValidate.uid" :maxlength="10" :disabled="disable"></Input>
                </Form-item>
              </Col>
              <Col :sm="11" :md="5">
                <Form-item label="学生姓名" prop="nickname">
                  <Input readonly placeholder="只读" v-model="formValidate.nickname" :disabled="disable"></Input>
                </Form-item>
              </Col>
              <Col :sm="11" :md="5">
                <Form-item label="课程顾问" prop="adviserName">
                  <Input readonly placeholder="只读"
                         v-model="formValidate.adviserName" :disabled="disable"></Input>
                </Form-item>
              </Col>
              <Col :sm="11" :md="5">
                <Form-item label="学导" prop="studyAdviserName">
                  <Input readonly placeholder="只读"
                         v-model="formValidate.studyAdviserName" :disabled="disable"></Input>
                </Form-item>
              </Col>
            </Row>
            <Row>
              <Col :sm="22" :md="18">
                <Form-item label="内容" prop="content">
                  <Input v-model="formValidate.content" type="textarea" :autosize="{minRows: 3, maxRows: 10}"></Input>
                  <div style="margin-top: 8px">
                    <Button type="primary" ghost size="small" :loading="aiLoading" :disabled="aiLoading" @click="handleAiMarkdown">AI 处理</Button>
                    <span style="margin-left: 8px; color: #999; font-size: 12px">将通话/听记原文清洗为结构化 Markdown</span>
                  </div>
                </Form-item>
              </Col>
            </Row>
            <Row>
              <Col :sm="11" :md="5">
                <Form-item label="下次联系日期">
                  <Date-picker type="date" :clearable="false" @on-change="nextTimeDateChange"
                               v-model="formValidate.nextTimeDate"></Date-picker>
                </Form-item>
              </Col>
              <Col :sm="11" :md="5">
                <Form-item label="下次联系人">
                  <Select v-model.number="formValidate.nextHandlerId" transfer>
                    <Option v-for="item in nextHandler"
                            :value="item.id" :key="item.id">{{ item.nickname }}
                    </Option>
                  </Select>
                </Form-item>
              </Col>
              <Col :sm="11" :md="5">
                <Form-item label="记录属性" prop="traceType">
                  <Select v-model="formValidate.traceType" transfer>
                    <Option value="1">新注册学生</Option>
                    <Option value="11">分配记录</Option>
                    <Option value="21">试听课记录</Option>
                    <Option value="31">成交记录</Option>
                    <Option value="41">交接记录</Option>
                    <Option value="51">绑定记录</Option>
                    <Option value="61">上课跟进记录</Option>
                    <Option value="71">转介绍跟进记录</Option>
                    <Option value="99">其他</Option>
                  </Select>
                </Form-item>
              </Col>
              <Col :sm="11" :md="5">
                <Form-item label="上传截图" prop="url">
                  <multiple-image-upload :num="100" :defaultFileList="defaultPicList" v-model="formValidate.files" on-file-change="onFileChange"/>
                </Form-item>
              </Col>
            </Row>
            <Form-item>
              <Button type="primary" @click="handleSubmit">提交</Button>
            </Form-item>
          </Form>
          <div>
            <!--<scroll height="800">-->
            <table class="track-list" style="width: 100%">
              <thead>
              <tr>
                <th width="4%">序号</th>
                <th width="10%">记录属性</th>
                <th width="16%">添加时间</th>
                <th width="40%">内容</th>
                <th class="next-handler-time-col">下次联系日期</th>
                <th width="10%">下次联系人</th>
                <th width="10%">操作人</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in tableData">
                <td>{{ index }}</td>
                <td :rowspan="item.rowSpan" :hidden="item.hidden">{{ item.showName }}</td>
                <td>
                  <span>{{ item.createTime }}</span>
                </td>
                <td>
                  <TrackContentPreview :content="item.content" @view="openTrackContent(item)">
                    <a v-if="item.showName == '注册学员备注' && item.nickname && item.nickname.trim() !== ''"
                       href="javascript:void(0)"
                       style="margin-left:8px"
                       @click="viewPic(item)">查看图片</a>
                  </TrackContentPreview>
                </td>
                <td class="next-handler-time-col">
                  <span class="next-handler-time-text" :title="formatNextHandlerTime(item)">{{ formatNextHandlerTime(item) }}</span>
                </td>
                <td>{{ item.nextHandlerName }}</td>
                <td>{{ item.createName }}</td>
              </tr>
              </tbody>
            </table>
            <!--</scroll>-->
            <Page :total="traceParam.totalCount" show-elevator className="page" :current="traceParam.pageIndex"
                  :pageSize="traceParam.pageSize" @on-change="changePageIndex" show-total></Page>
          </div>
        </Tab-pane>
      </Tabs>
      <div slot="footer" style="display: none;"></div>
    </Modal>
    <RecommendTeacher :value="recommendEdit" :uid="formData.uid" @on-close="closeRecommendEdit"></RecommendTeacher>
    <StageReportModal v-model="StageReportModal" :uid="formData.uid" :successCallback="reportList"></StageReportModal>
    <EvaluationSheetModal :reprotId="reprotId" v-model="showEvaluationSheetModal" :successCallback="reportList"
                          @on-close="onEvaluationSheetModalClose"></EvaluationSheetModal>
    <ShowImageCarousel :imgList="showImgList" :value="showImgModal" @on-close="closeImgModal"></ShowImageCarousel>
    <UserTrackContentModal ref="trackContentModal"></UserTrackContentModal>
  </div>

</template>
<script>
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
import SingleOnePicUpload from '../common/SingleOnePicUpload.vue'
import RecommendTeacher from './RecommendTeacherModal.vue'
import RecommendList from '../common/RecommendList.vue'
import VDistpicker from 'v-distpicker'
import StageReportModal from './StageReportModal.vue'
import EvaluationSheetModal from './EvaluationSheetModal.vue'
import Vue from 'vue'
import ShowImageCarousel from '../order/ShowImageCarousel'
import UserTrackContentModal from '../user/UserTrackContentModal.vue'
import TrackContentPreview from '../user/TrackContentPreview.vue'

export default {
  components: {
    TrackContentPreview,
    ShowImageCarousel,
    SingleOnePicUpload,
    RecommendTeacher,
    RecommendList,
    VDistpicker,
    StageReportModal,
    EvaluationSheetModal,
    UserTrackContentModal,
  },
  name: 'UserInfoModal',
  dialLoading: false,
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    },
    uid: {
      type: Number,
      default: null,
    },
    tabValue: {
      type: Number,
      default: null,
    }
  },
  data() {
    let $constant = this.$constant
    let $moment = this.$moment
    return {
      rankScoreSeq: 0,
      askForTch: false,
      nextDate: '',
      reprotId: null,
      cityInfo: '',
      insertLoading: false,
      showImgModal: false,
      StageReportModal: false,
      showEvaluationSheetModal: false,
      showImgList: [],
      defaultPicList: [],
      followList: [],
      imageUrl: 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg',
      reload: 0,
      text: '编辑头像',
      totalImageUrl: '',
      recommendData: null,
      paramsErrors: [],
      recommendEdit: false,
      reset: false,
      tabName: 0,
      placeholders: {
        province: '------- 省 --------',
        city: '--- 市 ---',
        area: '--- 区 ---',
      },
      formData: {
        uid: null,
        reprotId: null,
        itemUrl: '',
        enName: '',
        cnName: '',
        canal: '',
        payCanal: '',
        mobile: '',
        phoneRole: '',
        weChat: '',
        infoRemark: '',
        address: '',
        learnEnglishTime: '',
        haveContactForeignTeacher: '',
        familyEconomicSituation: '',
        attentionEnglish: '',
        province: '',
        city: '',
        block: '',
        sex: '',
        password: '',
        imageUrl: '',
        intentLevel: '',
        age: '',
        connectionStatus: '',
        userContacts: [],
        grade: '',
        birthday: null
      },
      followFormData: {
        id: '',
        nickname: '',
        adviserName: '',
        studyAdviserName: '',
        tchNames: [],
        traceStatus: '',
        traceItem: '',
        content: '',
        nextDate: '',
        files: '',
        stuDescCheckGroup: [],
        askForTchCheckGroup: [],
      },
      nextHandler: [],
      uidReadonly: false,
      disable: false,
      aiLoading: false,
      formValidate: {
        id: '',
        uid: null,
        nickname: '',
        adviserName: '',
        studyAdviserName: '',
        content: '',
        contentRaw: '',
        nextHandlerId: null,
        status: '0',
        traceType: '',
        nextHandlerTime: '',
        nextTimeDate: '',
        files: '',
      },
      traceParam: {
        totalCount: 0,
        pageSize: 10,
        pageIndex: 1,
        uid: ''
      },
      tableData: [],
      ruleValidate: {
        content: [
          {required: true, message: '内容不能为空', trigger: 'blur'},
          {type: 'string', max: 10000, message: '内容不能超过10000个字', trigger: 'blur'}
        ],
        traceType: [
          {required: true, message: '属性不能为空', trigger: 'blur'},
        ],
        nextHandlerId: [
          {type: 'number', required: true, message: '请选择下次联系人', trigger: 'blur'},
        ]
      },
      telDetails: [],
      userModal: null,
      studentNature: [],
      studyExperience: [],
      hobby: [],
      englishLevel: [],
      tchRequirement: [],
      queryParam: {
        intentLevel: '',
        uid: '',
      },
      title: [
        {
          title: '拨打时间',
          render: (h, params) => {
            let time = params.row.begin / 1000
            return h('span', time && $moment(time, 'X').format('YYYY-MM-DD'))
          }
        },
        {
          title: '通话类型',
          render: (h, params) => {
            let status = params.row.callState
            let typeEnum = $constant.getEnum($constant.telCallState, status)
            return h('span', typeEnum && typeEnum.text)
          }
        },
        {
          title: '通话状态',
          render: (h, params) => {
            let status = params.row.state
            let typeEnum = $constant.getEnum($constant.telState, status)
            return h('span', typeEnum && typeEnum.text)
          }
        },
        {
          title: '通话时长(秒)',
          render: (h, params) => {
            let row = params.row
            return h('span', (row.end - row.begin) / 1000)
          }
        },
        {
          title: '通话人',
          key: 'agentName',
        },
        {
          title: '通话录音',
          render: (h, params) => {
            let row = params.row
            return h('a', {on: {click: () => this.downLoadTel(row)}}, '下载')
          }
        },
        {
          title: '备注',
        },
      ],
      visible: this.value,
      userRule: {
        mobile: [
          {required: true, message: '内容不能为空', trigger: 'blur'},
          {pattern: $constant.mobileRule, message: '只能限数字或-,请输入正确的手机号码', trigger: 'blur'}
        ],
        age: [
          {pattern: /^[0-9]+$/, message: '只能输入数字', trigger: 'blur'}
        ],
      },
      followRule: {
        traceStatus: [
          {required: true, message: '请选择状态', trigger: 'blur'}
        ],
        traceItem: [
          {type: 'integer', required: true, message: '请选择状态', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '内容不能为空', trigger: 'blur'}
        ],
      },
      followData: [],
      stageReportData: [],
      followtitle: [
        {
          title: '时间',
          width: 100,
          key: 'gmtCreate',
        },
        {
          title: '状态',
          width: 110,
          render: (h, params) => {
            if (params.row.traceStatus == 100 || params.row.creatorName === '注册备注') return h('span', '注册备注')
            let traceStatus = params.row.traceStatus
            let traceStatusEnum = $constant.getEnum($constant.traceStatus, traceStatus)
            return h('span', traceStatusEnum && traceStatusEnum.text)
          }
        },
        {
          title: 'follow up选项',
          key: 'traceItem',
          width: 90,
          render: (h, params) => {
            let traceItem = params.row.traceItem
            let traceItemEnum = $constant.getEnum($constant.traceItem, traceItem)
            return h('span', traceItemEnum && traceItemEnum.text)
          }
        },
        {
          title: '内容',
          key: 'content',
        },
        {
          title: '下次联系时间',
          width: 100,
          key: 'nextContactTime',
        },
        {
          title: '处理人',
          width: 100,
          key: 'creatorName',
        },
      ],
      stageReportTitle: [
        {
          title: '老师ID/姓名',
          key: 'tchNameId',
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.tchNameId,
              score: row.monthRankScore
            })
          }
        },
        {
          title: '报告对应课节',
          key: 'lessonNum',
        },
        {
          title: '外管',
          key: 'studyName',
        },
        {
          title: '学导',
          key: 'tutorName',
        },
        {
          title: '阶段测评报告',
          render: (h, params) => {
            let row = params.row
            if (row.reportDoc !== '') {
              return h('div', [
                h('a', {on: {click: () => this.lookRerot(row.id)}}, '查看与编辑'),
                // h('pre', {class: 'f'}),
                //  h('a', {on: {click: () => this.dowlode(row.reportDoc)}}, '下载')
              ])
            }
          }
        },
        {
          title: '添加时间',
          key: 'gmtCreate',
        },
        {
          title: '添加人',
          key: 'creatorName',
        },
        {
          title: '状态',
          render: (h, params) => {
            let row = params.row
            if (row.status === 1) {
              return h('span', '待审核')
            } else {
              return h('span', '已通过')
            }
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            let row = params.row
            console.log(row.status)
            if (row.status === 2) {
              return h('span', '')
            } else {
              return h('div', [
                h('a', {
                  on: {
                    click: () => {
                      this.editReport(row.id, 2)
                    }
                  }
                }, '通过'),
              ])
            }
          }
        },
      ],
      recommendTitle: [
        {
          title: '老师ID/姓名',
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.tchId + '-' + row.firstName + ' ' + row.lastName,
              score: row.monthRankScore
            })
          }
        },
        {
          title: '类型',
          render: (h, params) => {
            let row = params.row
            let cons = this.$constant.getEnum(this.$constant.teacherCategory, row.category)
            return h('span', cons && cons.text)
          }
        },
        {
          title: '授课类型',
          render: (h, params) => {
            let row = params.row
            let cons = this.$constant.getEnum(this.$constant.tchType, row.tchType)
            return h('span', cons && cons.text)
          }
        },
        {
          title: '性别',
          render: (h, params) => {
            let row = params.row
            let cons = this.$constant.getEnum(this.$constant.sex, row.sex)
            return h('span', cons && cons.text)
          }
        },
        {
          title: '口音',
          render: (h, params) => {
            let row = params.row
            let cons = this.$constant.getEnum(this.$constant.accent, row.accent)
            return h('span', cons && cons.text)
          }
        },
        {
          title: '年龄',
          key: 'age',
        },
        {
          title: '推荐理由',
          key: 'reason',
        },
        {
          title: '推荐人',
          key: 'recommendName',
        },
        {
          title: '取消人',
          key: 'cancelName',
        },
        {
          title: '操作',
          render: (h, params) => {
            let row = params.row
            if (row.status === 1) {
              return h('a', {on: {click: () => this.cancelRecommend(row.id)}}, '取消推荐')
            } else {
              return h('span', '已取消')
            }
          }
        },
      ],
    }
  },
  methods: {
    loadMonthRankScoresFor (rows, idKey) {
      idKey = idKey || 'tchId'
      if (!rows || !rows.length) {
        return
      }
      const ids = []
      rows.forEach(function (row) {
        let id = row[idKey]
        if ((id == null || id === '') && row.tchNameId) {
          const matched = String(row.tchNameId).match(/^(\d+)/)
          if (matched) {
            id = Number(matched[1])
            row._scoreTchId = id
          }
        }
        if (id != null && id !== '') {
          ids.push(id)
        }
      })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, rows, idKey, 'monthRankScore', map)
        rows.forEach(function (row) {
          if (row.monthRankScore == null && row._scoreTchId != null) {
            let score = map[row._scoreTchId]
            if (score == null) {
              score = map[String(row._scoreTchId)]
            }
            if (score != null) {
              self.$set(row, 'monthRankScore', score)
            }
          }
        })
      })
    },

    formatNextHandlerTime (item) {
      let time = item && item.nextHandlerTime
      if (!time || time === '0000-00-00 00:00:00') {
        return '0'
      }
      return time
    },
    onEvaluationSheetModalClose() {
      this.showEvaluationSheetModal = false
      this.reprotId = null
    },
    changeDate(value) {
      this.followFormData.nextDate = value
    },
    onSelectedProvince(data) {
      if (data.value) {
        this.formData.province = data.value
      }
    },
    onSelectedCity(data) {
      if (data.value) {
        this.formData.city = data.value
      }
    },
    onSelectedArea(data) {
      if (data.value) {
        this.formData.block = data.value
      }
    },
    cancelRecommend(id) {
      let self = this
      this.$http.post('/tchRecommend/cancelRecommend', {id: id}).then(function (res) {
        if (res.data > 0) {
          self.$Message.success('取消成功!')
          self.searTchRecommend()
        }
      })
    },
    onTabClick(name) {
      // 触发推荐老师展示
      if (name === 2) {
        this.searTchRecommend()
      }
    },
    searTchRecommend() {
      let self = this
      this.$http.get('/tchRecommend/list?uid=' + this.uid + '&pageSize=' + 10).then(function (res) {
        if (res.data) {
          self.recommendData = res
          self.loadMonthRankScoresFor((self.recommendData && self.recommendData.data) ? self.recommendData.data : self.recommendData, 'tchId')
        }
      })
    },
    closeRecommendEdit() {
      this.searTchRecommend()
      this.recommendEdit = false
    },
    openRecommendEdit() {
      this.recommendEdit = true
    },
    deleteContact(val) {
      let contact = this.formData.userContacts
      let newContact = []
      for (let i in contact) {
        if (i !== val + '') {
          newContact.push(contact[i])
        }
      }
      this.formData.userContacts = newContact
    },
    addContact() {
      if (this.formData.userContacts.length >= 3) {
        this.$Message.warning('已到添加号码上限!')
        return
      }
      let contact = {}
      this.formData.userContacts.push(contact)
    },
    openStudentPage() {
      let self = this
      this.$http.get('/adminUser/getAdminToken?type=student').then(res => {
        if (res.data) {
          if (self.$appConfig.active === 'prod'){
            window.open('https://hellokid.speakstreet.cn/adminUserLogin?mobile=' + self.formData.mobile + '&token=' + res.data)
          } else {
            window.open('https://test-student.kouyujie.cn/adminUserLogin?mobile=' + self.formData.mobile + '&token=' + res.data)
          }
        }
      })
      return
    },
    lookRerot(id) {
      if (id) {
        this.reprotId = id
        this.showEvaluationSheetModal = true
        // window.open('http://medias.kouyujie.cn/' + url)
      }
    },
    editReport(id, status) {
      let self = this
      if (id) {
        let path = '/stageReport/update?id=' + id + '&status=' + status
        self.$http.post(path, this.formData).then((res) => {
          if (res && res.data > 0) {
            self.$Message.success('操作成功!')
            self.reportList()
          }
        })
      }
    },
    reportList() {
      let self = this
      self.$http.get('/stageReport/list?uid=' + self.followFormData.id).then(function (res) {
        if (res.data) {
          self.stageReportData = res.data
          self.loadMonthRankScoresFor(self.stageReportData, 'tchId')
        }
      })
    },
    insertReport() {
      this.StageReportModal = true
    },
    downLoadTel(row) {
    },
    search() {
      let self = this
      self.$http.get('/tel/listPersonDetails', self.queryParam).then(function (res) {
        if (res.data.data) {
          self.telDetails = res.data
        }
      })
    },
    onLoading(loading) {
      this.insertLoading = loading
    },
    changeFollow(val) {
      let self = this
      if (!val) {
        return
      }
      self.followFormData.traceItem = ''
      if (val === '100') {
        self.followList = [{id: 100, text: '注册备注'}]
        self.followFormData.traceItem = 100
      }
      if (val === '1') {
        self.followList = [{id: 1, text: '课后-同意购买'}, {id: 2, text: '课后-付款成功，持续跟进'}]
      }
      if (val === '2') {
        self.followList = [{id: 3, text: '课后-讲解产品，学习方案'}]
      }
      if (val === '3') {
        self.followList = [{id: 4, text: '课后-开场'}, {id: 5, text: '课前跟进，确认出席'}, {
          id: 6,
          text: '课前跟进，改期'
        }, {id: 7, text: '课前约课'}]
      }
      if (val === '4') {
        self.followList = [{id: 8, text: '价格问题'}, {id: 9, text: '行业对比'}, {id: 10, text: '不信任'}, {
          id: 11,
          text: '级别年龄不符'
        }]
      }
      if (val === '5') {
        self.followList = [{id: 12, text: '无人接听'}, {id: 13, text: '挂断'}, {id: 14, text: '关机/停机'}, {
          id: 15,
          text: '空号'
        }]
      }
    },
    addFollow() {
      let self = this
      self.$refs.followForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          return
        }
        if (self.followFormData.id) {
          if (self.followFormData.traceStatus == 100 || self.followFormData.traceStatus == '100') {
            self.$http.post('/userTrack/insert', {
              uid: self.followFormData.id,
              content: self.followFormData.content,
              files: self.followFormData.files || '',
              traceType: 100
            }).then(function (res) {
              if (res && res.data > 0) {
                self.$Message.success('保存成功!')
                self.followFormData.traceStatus = ''
                self.followFormData.traceItem = ''
                self.followFormData.content = ''
                self.followFormData.nextDate = ''
                self.followFormData.files = ''
                self.nextDate = ''
                self.askForTch = false
                self.$http.get('/saleTrace/followUp?id=' + self.followFormData.id).then(function (res) {
                  if (res && res.data) {
                    self.followData = res.data.list
                  }
                })
              }
            })
            return
          }
          let requireNum = []
          requireNum.push(...self.followFormData.stuDescCheckGroup)
          requireNum.push(...self.followFormData.askForTchCheckGroup)
          self.$http.post('/saleTrace/insert', {
            uid: self.followFormData.id,
            traceStatus: self.followFormData.traceStatus,
            traceItem: self.followFormData.traceItem,
            content: self.followFormData.content,
            nextDate: self.followFormData.nextDate,
            requireNum: requireNum.toString()
          }).then(function (res) {
            if (res && res.data > 0) {
              self.$Message.success('保存成功!')
              self.followFormData.traceStatus = ''
              self.followFormData.traceItem = ''
              self.followFormData.content = ''
              self.followFormData.nextDate = ''
              self.nextDate = ''
              self.askForTch = false
              self.$http.get('/saleTrace/followUp?id=' + self.followFormData.id).then(function (res) {
                if (res && res.data) {
                  self.followData = res.data.list
                }
              })
            }
          })
        }
      })
    },
    resetRequireNum() {
      this.nextDate = ''
      this.followFormData.askForTchCheckGroup = []
      this.followFormData.stuDescCheckGroup = []
      this.askForTch = false
    },
    addStudent() {
      let self = this
      self.insertLoading = true
      let res = self.valiDateParam()
      if (!res) {
        this.$Message.warning('参数输入错误!')
        if (self.paramsErrors.length > 0) {
          for (let i in self.paramsErrors) {
            this.$Message.warning(self.paramsErrors[i])
          }
          self.paramsErrors = []
        }
        self.insertLoading = false
        return
      }
      if (self.formData.birthday) {
        self.formData.birthday = self.formData.birthday / 1000
      }
      if (!self.formData.uid) {
        self.$http.get('/user/queryByMobile?mobile=' + self.formData.mobile).then(function (res) {
          if (res.data) {
            this.$Message.warning('学员手机号已经存在!')
          }
        })
        self.$http.post('/userinfo/insertUserInfo', JSON.stringify(self.formData)).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false
            self.$Message.success('新增成功!')
            self.successCallback()
          }
          self.insertLoading = false
        }).catch(function (e) {
          self.visible = false
          self.insertLoading = false
        })
      } else {
        self.$http.post('/userinfo/updateUserInfo', {}, {
          transformRequest: [function (data, headers) {
            return JSON.stringify(self.formData)
          }],
          headers: {'Content-Type': 'application/json;charset=utf-8'},
        }).then(function (res) {
          self.insertLoading = false
          if (res) {
            self.$Message.success('修改成功!')
            self.visible = false
            return
          }
        }).catch(function (e) {
          self.insertLoading = false
        })
      }
    },
    valiDateParam() {
      let self = this
      let isPass = false
      self.$refs.userInfoForm.validate((valid) => {
        let res = self.valiDateMobile()
        if (valid && res) {
          isPass = true
        }
      })
      return isPass
    },
    valiDateMobile() {
      let isPass = false
      let self = this
      let pattern = /^[0-9]+$/
      if (self.formData.userContacts && self.formData.userContacts.length > 0) {
        for (let i in self.formData.userContacts) {
          let param = self.formData.userContacts[i]
          if (!param.name) {
            self.paramsErrors.push('联系人名字不能为空!')
          } else if (!param.mobile) {
            self.paramsErrors.push('联系人号码不能为空!')
          } else if (!pattern.test(param.mobile)) {
            self.paramsErrors.push('手机号只能输入数字!')
          } else {
            isPass = true
          }
        }
      }
      if (self.paramsErrors && self.paramsErrors.length > 0) {
        isPass = false
      } else {
        isPass = true
      }
      return isPass
    },
    dialTel() {
      // 待增加,呼出电话功能
      if (!this.formData.mobile) {
        this.$Message.warning('无效手机号码')
        return
      }
      this.dialLoading = true
      let self = this
      this.$http.get('/moor/call?callNo=' + this.formData.mobile).then(function (res) {
        if (res.data > 0) {
          self.$Message.success('呼出成功!')
          self.dialLoading = false
        }
      })
    },
    handleResult(file) {
      this.formData.imageUrl = file.name
      this.totalImageUrl = file.url
    },
    openTrackContent(item) {
      this.$refs.trackContentModal && this.$refs.trackContentModal.open(item)
    },
    handleAiMarkdown() {
      let self = this
      let content = (self.formValidate.content || '').trim()
      if (!content) {
        self.$Message.warning('请先填写内容')
        return
      }
      self.aiLoading = true
      self.$http.post('/userTrack/aiMarkdown', {content: content}).then(function (res) {
        self.aiLoading = false
        if (!res || res.status !== 'ok' || !res.data || !res.data.markdown) {
          return
        }
        let markdown = res.data.markdown
        self.$Modal.confirm({
          title: '确认覆盖',
          content: '将用 AI 结果覆盖当前内容，是否继续？',
          onOk: function () {
            if (!(self.formValidate.contentRaw || '').trim()) {
              self.formValidate.contentRaw = content
            }
            self.formValidate.content = markdown
            self.$Message.success('已用 AI 结果更新内容')
          }
        })
      }).catch(function () {
        self.aiLoading = false
      })
    },
    handleSubmit() {
      let self = this
      this.$refs.form.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          return
        }
        if (self.formValidate.nextHandlerTime || self.formValidate.nextHandlerId) {
          if (!self.formValidate.nextHandlerTime || !self.formValidate.nextHandlerId) {
            self.$Message.warning('请填写下次联系人和下次联系日期!')
            return
          }
        }
        self.$http.post('/userTrack/insert', self.formValidate).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('提交成功!')
            self.formValidate.content = ''
            self.formValidate.contentRaw = ''
            self.formValidate.nextHandlerId = null
            self.formValidate.nextHandlerTime = ''
            self.formValidate.traceType = ''
            self.formValidate.nextTimeDate = ''
            self.getPersonTrace(self.formValidate.uid)
          }
        })
      })
    },
    nextTimeDateChange(value) {
      this.formValidate.nextHandlerTime = value
    },
    getPersonTrace(uid) {
      let self = this
      let params = self.traceParam
      if (uid) {
        self.$http.get('/userTrack/getPersonTrace?uid=' + uid + '&pageIndex=' + params.pageIndex + '&pageSize=' + params.pageSize).then(function (res) {
          if (!res.data || !res.data.data) {
            self.traceParam.totalCount = 0
            self.tableData = []
            return
          }
          self.traceParam.uid = res.data.data[0].uid
          self.traceParam.nickName = res.data.data[0].nickname
          self.traceParam.totalCount = res.data.totalCount
          self.tableData = res.data.data
        })
      }
    },
    changePageIndex(page) {
      this.traceParam.pageIndex = page
      this.getPersonTrace(this.traceParam.uid)
    },
    viewPic(row) {
      this.showImgList = row.nickname ? row.nickname.split(',').map(item => {
        if (!item.startsWith('http')) {
          return 'https://imgs.speakstreet.cn/' + item
        }
        return item
      }) : []
      this.showImgModal = true
    },
    closeImgModal() {
      this.showImgList = []
      this.showImgModal = false
    },
  },
  watch: {
    value(val) {
      this.visible = val
    },
    visible(val) {
      this.tabName = 0
      this.reset = true
      Vue.set(this.formData, 'userContacts', {})
      if (val === false) {
        this.followFormData.traceStatus = ''
        this.followFormData.traceItem = ''
        this.followFormData.content = ''
        this.followFormData.nextDate = ''
        this.followFormData.files = ''
        this.resetRequireNum()
        this.$emit('on-close', val)
      } else {
        this.reset = false
      }
    },
    uid(val) {
      let self = this
      if (val) {
        self.formData.uid = val
        self.$http.get('/saleTrace/followUp?id=' + val).then(function (res) {
          if (res.data) {
            self.followFormData.id = res.data.id
            self.followFormData.adviserName = res.data.adviserName
            self.followFormData.nickname = res.data.nickname
            self.followFormData.studyAdviserName = res.data.studyAdviserName
            let requireNum = res.data.requireNum
            if (requireNum) {
              let require = requireNum.split(',')
              for (let i in require) {
                let j = parseInt(require[i])
                let len = self.$constant.stuDesc.length + 1
                if (j < len) {
                  self.followFormData.stuDescCheckGroup.push(j)
                } else {
                  self.followFormData.askForTchCheckGroup.push(j)
                }
              }
            }
            self.formValidate.uid = val
            self.formValidate.nickname = res.data.nickname
            self.formValidate.adviserName = res.data.adviserName
            self.formValidate.studyAdviserName = res.data.studyAdviserName
            self.followFormData.tchNames = res.data.tchNames
            self.followData = res.data.list
          }
        })
        this.$http.post('/adminUser/listByCondition', {status: 1}).then(function (res) {
          self.nextHandler = res.data
        })
        self.getPersonTrace(val)
        self.$http.get('/stageReport/list?uid=' + val).then(function (res) {
          if (res.data) {
            self.stageReportData = res.data
          }
        })
        self.$http.get('/userinfo/getUserInfo?uid=' + val).then(function (res) {
          if (res.data) {
            let data = res.data
            self.formData.enName = data.enName
            self.formData.cnName = data.cnName
            self.formData.sex = data.sex
            self.formData.regType = data.regType
            self.formData.payCanal = data.payCanal
            self.formData.mobile = data.mobile
            self.formData.phoneName = data.phoneName
            self.formData.weChat = data.weChat
            self.formData.phoneRole = data.phoneRole
            self.formData.infoRemark = data.infoRemark
            self.formData.address = data.address
            self.formData.learnEnglishTime = data.learnEnglishTime + ''
            self.formData.haveContactForeignTeacher = data.haveContactForeignTeacher
            self.formData.familyEconomicSituation = data.familyEconomicSituation
            self.formData.attentionEnglish = data.attentionEnglish
            self.formData.province = data.province
            self.formData.city = data.city
            self.formData.block = data.block
            self.formData.imageUrl = data.imageUrl
            self.formData.age = data.age
            self.formData.intentLevel = data.intentLevel
            self.formData.connectionStatus = data.connectionStatus
            self.formData.userContacts = data.userContacts
            self.formData.grade = data.grade
            self.formData.birthday = data.birthday * 1000
            if (data.imageUrl) {
              if (data.imageUrl.indexOf('http://') !== -1) {
                self.totalImageUrl = data.imageUrl
              } else {
                if (data.imageUrl.substr(0, 1) === '/') {
                  self.totalImageUrl = 'http://medias.kouyujie.cn' + data.imageUrl
                } else {
                  self.totalImageUrl = 'http://medias.kouyujie.cn/' + data.imageUrl
                }
              }
              self.text = '编辑头像'
            } else {
              self.totalImageUrl = 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg'
              self.text = '上传头像'
            }

            self.userModal = data.userModal
          }
        })
        self.queryParam.uid = val
        self.search()
      } else {
        self.formData.password = ''
      }
    },
    tabValue(val) {
      if (val) {
        this.tabName = val
      } else {
        this.tabName = 0
      }
    },
    cityInfo(val) {
      if (val) {
        this.formData.province = val.province.name
        this.formData.city = val.city.name
        this.formData.block = val.block.name
      }
    }
  },
  created: function () {
  },
  mounted: function () {
  },
}
</script>



// WEBPACK FOOTER //
// UserInfoModal.vue?427a5beb